module.exports = __webpack_public_path__ + "static/linkedin-logo-ads-e24fa937acc74a7f1a92d477bedc46f3.png";